<template>
  <section class="layout-section">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Contenu éditorial</h2>
      <p>
        Ces modèles de présentation assurent une structure claire et cohérente pour les contenus éditoriaux. En
        utilisant des mises en page répétables et harmonisées, on facilite la lecture et on renforce l’uniformité
        visuelle à travers l’ensemble du site.
      </p>
    </div>

    <br />

    <article class="article-pdf -accent">
      <div class="article-pdf__info">
        <div class="article-pdf__figure -accent">
          <SvgIcon id="file-pdf" />
        </div>

        <p>Nom du fichier</p>
      </div>

      <div class="article-pdf__info -alt">
        <p>133.94 Ko</p>
        <SvgIcon id="file-download" />
      </div>
    </article>

    <article class="article-pdf">
      <div class="article-pdf__info">
        <div class="article-pdf__figure">
          <SvgIcon id="content-people" />
        </div>

        <p>Nom du collaborateur</p>
      </div>
    </article>

    <br />

    <article class="layout-grid">
      <p class="layout-section__note">Autres layouts à venir... Mise en ligne prochainement</p>
    </article>
  </section>
</template>

<script>
export default {
  name: 'DemoArticle'
}
</script>
